export default __webpack_public_path__ + "static/media/assembly_7.af24e4d3.webp";